<template>
  <div id="login" class="bgPage">
    <div v-if="resCol === '6'" class="pa-3"
      style="background-color: #16163f;color: white;display: flex;padding-right: 70px !important;;padding-left: 70px !important;justify-content: space-between;">
      <div style="display: flex;">
        <div class="mr-3">
          <v-icon color="white" class="mr-2">mdi-email</v-icon>support@betaskthai.com
        </div>
        <div class="mr-3">
          <v-icon color="white" class="mr-2">mdi-phone</v-icon>089-456-2288
        </div>
        <div>
          <v-icon color="white" class="mr-2">mdi-phone</v-icon>08-1929-3917
        </div>
      </div>
      <div style="display: flex;">
        <div
          style="background-color: #09a909;background-color: rgb(9, 169, 9);border-radius: 34px;padding: 2px;padding-right: 10px;padding-left: 10px;font-size: 13px;"
          class="mr-5">
          <v-icon class="iconify" color="white" data-icon="cib:line"></v-icon> ADD FREIND
        </div>
        <v-icon color="white" class="mr-5">mdi-facebook</v-icon>
        <!-- <v-ico >mdi-facebook</v-ico> -->
        <v-icon class="iconify mr-5" data-icon="cib:tiktok" color="white"></v-icon>
        <v-icon color="white" class="mr-5">mdi-youtube</v-icon>
        <v-icon color="white" class="mr-5">mdi-twitter</v-icon>
      </div>
    </div>
    <Navbar />
    <!-- <div class="spinner-3"></div> -->
    <v-row>
      <v-col cols="12" md="6" align="center" :style="resCol === '6' ? 'padding-top: 60px;' : 'padding-top: 20px'">
        <v-img contain width="60%" :src="require('@/assets/Character_BeLoyalty_01-01.png')"></v-img>
        <!-- <v-img
                contain
                width="60%"
                :src="require('@/assets/Mascot-Betask.png')"
              ></v-img> -->
      </v-col>
      <v-col>
        <v-container fluid
          :style="resCol === '6' ? 'padding-top: 120px;display: flex;justify-content: center;' : 'padding-top: 0'">
          <div class="background-login" :style="resCol === '6' ? 'width: 520px;' : ''">
            <v-row class="text-center" justify="center" no-gutters>
              <v-col cols="10">
                <h2>
                  <strong style="color:black">เข้าสู่ระบบ BeTask</strong>
                </h2>
                <p><strong style="color:#709e69;">ลงชื่อเข้าใช้บัญชีของคุณ</strong></p>
              </v-col>
            </v-row>
            <div>
              <v-row justify="center" no-gutters>
                <v-col cols="10" class="pa-0 mb-3">
                  <p class="text-left" style="margin: 0 0 8px;">อีเมล</p>
                  <v-text-field placeholder="อีเมล" style="background-color:white;"
                    prepend-inner-icon="mdi-email-outline" outlined autofocus hide-details :rules="[rules.email]"
                    v-model="form.userName" @keyup.enter="onSubmit()"></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center" no-gutters style="height: 90px">
                <v-col cols="10" class="pa-0 mb-3">
                  <p class="text-left" style="margin: 0 0 8px;">รหัสผ่าน</p>
                  <v-text-field placeholder="รหัสผ่าน" prepend-inner-icon="mdi-lock-open-outline" outlined hide-details
                    :rules="[rules.required]" style="background-color:white;" v-model="form.userPassword"
                    @keyup.enter="onSubmit()" type="password"></v-text-field>
                </v-col>
              </v-row>
              <!-- <v-row justify="center" no-gutters style="height: 70px">
              <v-col cols="10" style="display: flex; justify-content: center">
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="verifyMethod"
                  @render="renderMethod"
                  sitekey="6Lef5A8hAAAAAIffpLLp_mpt_UFbcuq6l_mXbh8e"
                ></vue-recaptcha>
              </v-col>
            </v-row> -->
              <!-- <v-row>
              <v-col class="text-right">
                <v-btn
                  plain
                  color="primary"
                  dark
                >
                  สมัคร LINE OA
                </v-btn>
              </v-col>
              <v-col class="text-left">
                <v-btn
                  plain
                  color="primary"
                  dark
                >
                  สมัครบัญชี
                </v-btn>
              </v-col>
            </v-row> -->
              <v-row v-if="recapStatus" justify="center" class="mt-3" no-gutters style="height: 40px">
                <v-col cols="10">
                  <v-alert text outlined type="error">
                    กรุณากดยืนยันตัว.
                  </v-alert>
                </v-col>
              </v-row>
              <v-row justify="center" no-gutter>
                <v-col cols="10" class="coll">
                  <v-btn color="rgb(72 89 176)" style="font-size: 20px;border-radius: 40px;" dark x-large block
                    @click="onSubmit()">
                    เข้าสู่ระบบ
                  </v-btn>
                </v-col>
              </v-row>
              <!-- <v-col style="display: flex; justify-content: center">
                  <div class="mr-1" style="font-size: 18px">ลืม?</div>
                  <div
                    style="
                        font-size: 18px;
                        color: #001d6e;
                        cursor: pointer;
                        text-decoration: underline;
                      "
                    @click=";(dialog = true), validate('UPDATE')"
                  >
                    รหัสผ่าน
                  </div>
                </v-col>
                <v-col>
                  <h6>
                    คุณได้ลงทะเบียนแล้วหรือยัง?
                    <a
                      style="cursor: pointer; text-decoration: underline"
                      href="https://belinked.betaskthai.com/register"
                      >ลงทะเบียน!</a
                    >
                  </h6>
                </v-col> -->
            </div>
          </div>
        </v-container>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogPaymentUpload" persistent max-width="500px" style="overflow:hidden;">
      <v-card>
        <v-container>
          <div>
            <v-row>
              <v-col :cols="resCol === '6' ? '10' : '9'" class="text-left pt-5">
                <h3><strong>กรุณาชำระค่าบริการรายเดือน</strong></h3>
              </v-col>
              <v-col :cols="resCol === '6' ? '2' : '3'" class="pt-1">
                <div style="text-align: end;">
                  <v-btn class="mx-2" fab icon color="red" @click="(dialogPaymentUpload = false)">
                    <v-icon style="font-size: 30px;">mdi-close-circle</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
          <div>
            <v-row>
              <v-col cols="12">
                <v-btn elevation="2" x-large dark block style="border-radius: 10px;" color="#1B437C"
                  @click="gotoBilling(dataBilling)" :disabled="!validUpdate">
                  <v-icon left class="iconify" data-icon="medical-icon:billing"></v-icon>
                  ชำระค่าบริการ
                </v-btn>
              </v-col>
              <v-col cols="12">
                <h4>หากต้องการติดต่อเจ้าหน้าที่ กรุณาติดต่อที่ LINE OA : <a
                    href="https://lin.ee/8dJyn31">@betaskthai</a></h4>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="445">
      <v-card>
        <v-container>
          <v-card-text>
            <v-row class="mb-6" justify="center">
              <v-col md="auto">
                <v-img
                  src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-app%2FforgotPassword.svg?alt=media&token=18d74e00-5b29-4d54-983e-f4ae5587510a"
                  class="a" style="width: 103px; height: 103px"></v-img>
                <!-- <v-img
                        :src="require('@/assets/forgotPassword.svg')"
                        class="a"
                        style="width: 103px; height: 103px"
                      ></v-img> -->
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-row class="mb-6" justify="center" no-gutters>
              <v-col md="auto">
                <h1 style="font-size: 10vw" class="underline-06">
                  Forget Password?
                </h1>
              </v-col>
            </v-row>
            <v-form ref="form_update" v-model="validUpdate" lazy-validation>
              <v-row no-gutter>
                <v-subheader class="pl-16"><strong>Username/ Email</strong></v-subheader>
              </v-row>
              <v-row no-gutter justify="center">
                <v-col lg="12" class="pt-0 pb-0">
                  <v-text-field prepend-icon="mdi-account" v-model="form.newUserName" label="Username" solo
                    :rules="[rules.email]" required></v-text-field>
                </v-col>
                <v-col lg="12" class="pa-0">
                  <v-subheader class="pl-16">Enter you email address and we will send you an email for
                    reset password</v-subheader>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <br />
          <v-row justify="center" no-gutter>
            <v-col md="auto">
              <v-btn elevation="2" x-large dark color="#1B437C" @click="onSubmitForgot()" :disabled="!validUpdate">
                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                Reset Password
              </v-btn>
            </v-col>
          </v-row>
          <v-row justify="center" no-gutter>
            <v-col md="auto">
              <a class="v-subheader" @click="dialog = false">Return to Signin</a>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <div v-if="!dataReady" class="text-center">
      <waitingAlert></waitingAlert>
    </div>
  </div>
</template>
<script>
import waitingAlert from './waitingAlert.vue'
import axios from 'axios'
import VuetifyLogo from '../logo'
import Navbar from './Navbar'
// import VueRecaptcha from 'vue-recaptcha'
export default {
  components: {
    waitingAlert,
    VuetifyLogo,
    Navbar
    // 'vue-recaptcha': VueRecaptcha
  },
  name: 'Login',
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  // beforeCreate () {
  //   this.$liff.init({ liffId: this.$liff_id_login }, function (data) {})
  // },
  data () {
    return {
      session: this.$session.getAll(),
      cards: [
        {
          title: 'Favorite road trips',
          src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg',
          flex: 6
        },
        {
          title: 'Best airlines',
          src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg',
          flex: 6
        }
      ],
      queryData: '',
      bookNo: '',
      jobNo: '',
      dialog: false,
      dialogPopup: true,
      sheet: false,
      profile: [],
      privacyConfigDetail: '',
      privacyConfigCode: '',
      widthScreen: window.screen.width,
      dataBilling: null,
      dialogPaymentUpload: null,
      menu: [],
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      formCheckPrivacy: {
        privacyConfigCode: '',
        userCode: '',
        privacyStatus: '',
        userTypeGroup: ''
      },
      form: {
        userLineId: '',
        userLinepictureUrl: '',
        userName: '',
        newUserName: '',
        userPassword: '',
        newUserPassword: ''
      },
      dataReady: true,
      hidePrivacy: true,
      validUpdate: true,
      recapchaToken: '',
      recapStatus: false
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    // await this.checkLiffLogin()
    this.$session.destroy()
    this.$session.clear()
  },
  methods: {
    gotoBilling (item) {
      this.$session.start()
      this.$session.set('data', item)
      localStorage.clear()
      this.$router.push('/BillingPlan')
      console.log('item', item)
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    verifyMethod (a) {
      this.recapchaToken = a
      this.recapStatus = false
      console.log('tokeneiei', a)
    },
    renderMethod (c) {
      console.log('capchaeiei', c)
    },
    async onSubmit () {
      console.log(this.form.userPassword)
      this.dataReady = false
      this.form.type = 'username'
      await axios
        .get(
          this.DNS_IP +
          '/system_shop/auth?userName=' +
          this.form.userName +
          '&userPassword=' + encodeURIComponent(this.form.userPassword)
          // this.form.userPassword
        )
        .then(async response => {
          console.log(response.data)
          if (response.data.status === false) {
            this.$swal(
              'ไม่พบบัญชีผู้ใช้',
              'กรุณากรอกข้อมูลอีกครั้ง ',
              'error'
            )
            this.dataReady = true
          } else if (response.data[0].ExpireDateDiff < 1) {
            this.dataReady = true
            this.$swal(
              'ผิดพลาด',
              'Account หมดอายุ กรุณาติดต่อเจ้าหน้าที่',
              'error'
            )
          } else {
            this.$session.start()
            this.$session.set('data', response.data[0])
            localStorage.setItem('data', JSON.stringify(response.data[0]))
            this.formCheckPrivacy.userCode = response.data[0].userCode
            this.formCheckPrivacy.CREATE_USER = response.data[0].userName
            this.formCheckPrivacy.LAST_USER = response.data[0].userName
            this.formCheckPrivacy.userTypeGroup = response.data[0].userTypeGroup
            this.formCheckPrivacy.privacyStatus = 'Confirm'
            if (response.data[0].shopStatus === 'active') {
              await axios
                .get(
                  this.DNS_IP +
                  '/system_privacy_check/get?RECORD_STATUS=N&userCode='
                )
                .then(async response => {
                  this.$session.set('AccessKey', this.$route.query.access)
                  if (this.$route.query.callBack) {
                    if (this.$route.query.callBack === '/System/confrimPayment') {
                      this.$router.push('/System/confrimPayment')
                    } else if (this.$route.query.callBack.split('?')[0] === '/Master/PackageQRcode') {
                      this.$router.push(
                        '/Master/PackageQRcode?token=' +
                        this.$route.query.token +
                        '&memberId=' +
                        this.$route.query.memberId +
                        '&shopId=' +
                        this.$route.query.shopId +
                        '&tpk=' + this.$route.query.tpk
                      )
                    } else {
                      this.$router.push(
                        '/Core/Home?access=' +
                        this.$route.query.access +
                        '&callBack=' +
                        this.$route.query.callBack +
                        '&rewardId=' +
                        this.$route.query.rewardId +
                        '&rewardCode=' +
                        this.$route.query.rewardCode +
                        '&lineUserId=' +
                        this.$route.query.lineUserId
                      )
                    }
                  } else if (this.$route.query.token) {
                    this.$router.push(
                      '/Master/PackageQRcode?token=' +
                      this.$route.query.token +
                      '&memberId=' +
                      this.$route.query.memberId +
                      '&shopId=' +
                      this.$route.query.shopId +
                      '&tpk=' + this.$route.query.tpk
                    )
                  } else {
                    await axios
                      .get(
                        this.DNS_IP +
                        '/system_log_auth/get?logAuthStatus=Success&limit=2&CREATE_USER=' +
                        this.form.userName
                      )
                      .then(async response => {
                        if (response.data.length <= 1) {
                          this.$router.push('/Core/ReportActivity')
                        } else {
                          this.$router.push('/Core/ReportActivity')
                        }
                      })
                      .catch(error => {
                        this.dataReady = true
                        // alert('1')
                        this.$router.push('/Master/AddCoin')
                        console.log(error)
                      })
                  }
                })
                // eslint-disable-next-line handle-callback-err
                .catch(error => {
                  // เคย
                  axios
                    .post(
                      // eslint-disable-next-line quote
                      this.DNS_IP + '/system_privacy_check/add',
                      this.formCheckPrivacy
                    )
                    .then(async response => {
                      // console.log(response)
                      // this.getMenu(this.formCheckPrivacy)
                      // this.$router.push('/Core/Home')
                      this.$session.set('AccessKey', this.$route.query.access)
                      if (this.$route.query.callBack) {
                        if (this.$route.query.callBack === '/System/confirmPayment') {
                          this.$router.push('/System/confirmPayment')
                        } else if (this.$route.query.callBack.split('?')[0] === '/Master/PackageQRcode') {
                          let setShopId = this.$route.query.callBack.split('?')[1].split('=')[1]
                          // alert(this.$route.query)
                          this.$router.push(
                            '/Master/PackageQRcode?token=' +
                            this.$route.query.token +
                            '&memberId=' +
                            this.$route.query.memberId +
                            '&shopId=' +
                            setShopId +
                            '&tpk=' + this.$route.query.tpk
                          )
                        } else {
                          // alert('1')
                          this.$router.push(
                            '/Core/Home?access=' +
                            this.$route.query.access +
                            '&callBack=' +
                            this.$route.query.callBack +
                            '&rewardId=' +
                            this.$route.query.rewardId +
                            '&rewardCode=' +
                            this.$route.query.rewardCode +
                            '&lineUserId=' +
                            this.$route.query.lineUserId
                          )
                        }
                      } else {
                        await axios
                          .get(
                            this.DNS_IP +
                            '/system_log_auth/get?logAuthStatus=Success&limit=2&CREATE_USER=' +
                            this.form.userName
                          )
                          .then(async response => {
                            console.log('system_log_auth', response)
                            if (response.data.length <= 1) {
                              //   this.$router.push('/Core/Home?tour=true')
                              // alert('sas1')
                              this.$router.push('/Master/AddCoin')
                            } else {
                              if (this.$session.getAll().data.userTypeGroup === 'partner') {
                                this.$router.push('/Reports/reportPackage')
                              } else {
                                this.$router.push('/Master/AddCoin')
                              }
                            }
                          })
                        // eslint-disable-next-line handle-callback-err
                          .catch(error => {
                            this.dataReady = true
                            if (this.$session.getAll().data.userTypeGroup === 'partner') {
                              this.$router.push('/Reports/reportPackage')
                            } else {
                              this.$router.push('/Master/AddCoin')
                            }

                            console.log(error)
                          })
                      }
                    })
                    // eslint-disable-next-line handle-callback-err
                    .catch(error => {
                      this.dataReady = true
                      console.log(error)
                      this.$router.push(
                        '/system/Errorpage?returnLink=' + this.returnLink
                      )
                    })
                })
            } else {
              this.dataBilling = response.data[0]
              this.dataReady = true
              this.dialogPaymentUpload = true
            }
          }
        })
    },
    async onSubmitForgot () {
      // this.dataReady = false
      this.form.type = 'username'
      // console.log(JSON.stringify(this.form))
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/system_user/get?userName=' + this.form.newUserName
        )
        .then(async response => {
          if (response.data.status !== false) {
            if (response.data[0]) {
              var md5 = require('md5')
              let autogen = await this.generateCodeGlobal
              let token = md5(autogen)

              let dt = {
                refId: response.data[0].userId,
                typeJob: 'forgot',
                status: 'wait',
                token: token,
                CREATE_USER: response.data[0].userName,
                LAST_USER: response.data[0].userName
              }
              await axios
                .post(this.DNS_IP + '/token_email/add', dt)
                .then(async response1 => {
                  console.log('response1', response1.data.status)
                  if (response1.data.status) {
                    let dt = {
                      email: response.data[0].userName,
                      status: 'forgot',
                      token: token
                    }
                    await axios
                      .post(
                        'https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/Welcome-sendMail',
                        dt
                      )
                      .then(async response => {
                        this.dialog = false
                        this.$swal(
                          'เรียบร้อย',
                          'กรุณาตรวจสอบ Email ของท่าน',
                          'success'
                        )
                        // location.reload()
                        this.form.newUserName = ''
                      })
                  } else {
                    this.$swal('ผิดพลาด', 'กรุณาทำรายการใหม่', 'error')
                    this.form.newUserName = ''
                  }
                })
            } else {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'Account ไม่ถูกต้อง1', 'error')
            }
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          this.dataReady = true
          console.log(error)
          this.$swal('ผิดพลาด', 'Account ไม่ถูกต้อง2', 'error')
        })
    }
  }
}
</script>
<style scoped>
.v-list-item {
  background-color: #1b437c !important;
}

.bgPage {
  background: url("../../assets/bg.png");
  height: 100%;
  /* left: 0%;
        right: 0%;
        top: 0%;
        bottom: 0%; */
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

h1 {
  text-align: center;
}

.a>>>.ql-align-center {
  text-align: center;
}

a {
  color: #42b983;
}

#danger {
  color: red;
}

#login {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 100px;
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 60px; */
}

.v-subheader {
  color: #1b437c !important;
}

#xxxxxx {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}

hr {
  border: none;
  border-top: 4px dotted grey;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 50%;
  margin-top: 30px;
}

/* body {
        background-color: lightgreen;
      } */
.v-toolbar__content {
  padding: 4px 16px;
  justify-content: space-around !important;
}

.spinner-3 {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #7dacef;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: s3 1s infinite linear;
}

@keyframes s3 {
  to {
    transform: rotate(1turn);
  }
}

.row+.row {
  margin-top: 0px;
}

.v-text-field {
  padding: 0px !important;
}

.coll {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 25px;
}

.background-login {
  background-color: #ffffffcc;
  padding: 30px;
  border-radius: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Core/Login.vue